import { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { notification } from "antd";

//create AuthContext
const AuthContext = createContext();

export const AuthProvide = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const navigate = useNavigate();

  // const login = (username, password) => {
  //   if (username === "admin123" && password === "password123") {
  //     setUser({ username });
  //     localStorage.setItem("user", JSON.stringify({ username })); // Store in localStorage
  //     navigate("/admin");
  //   } else {
  //     throw new Error("Invalid credentials");
  //   }
  // };

  const login = (username, password) => {
    if (username === "admin123" && password === "password123") {
      const userData = { username };
      setUser(userData);
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("lastActivity", Date.now()); // Store activity time
      navigate("/admin");
    } else {
      throw new Error("Invalid credentials");
    }
  };

  const logout = (sessionExpired = false) => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("lastActivity");

    if (sessionExpired) {
      notification.warning({
        message: "Session Expired",
        description: "You have been logged out due to inactivity.",
      });
    }

    navigate("/login");
  };

  // useEffect(() => {
  //   const checkTimeout = () => {
  //     const lastActivity = localStorage.getItem("lastActivity");
  //     if (lastActivity && Date.now() - lastActivity > 10 * 60 * 1000) {
  //       logout(true); // Auto logout after 30 minutes
  //     }
  //   };

  //   const interval = setInterval(checkTimeout, 1000 * 60); // Check every 1 min

  //   return () => clearInterval(interval);
  // }, []);

  // const updateActivity = () => {
  //   localStorage.setItem("lastActivity", Date.now());
  // };

  // useEffect(() => {
  //   const events = ["mousemove", "keydown", "click"];
  //   events.forEach((event) => window.addEventListener(event, updateActivity));

  //   return () => {
  //     events.forEach((event) =>
  //       window.removeEventListener(event, updateActivity)
  //     );
  //   };
  // }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
